import React, { useState } from 'react';
import { BRANDFETCH_CLIENT_ID } from '../../constants';

// A play glyph in currentColor, the stand-in when the Hudl mark cannot load.
export const PlayGlyph = ({ size = 17 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M4.5 2.6c0-.8.9-1.3 1.6-.9l7.3 4.5c.7.4.7 1.4 0 1.8l-7.3 4.5c-.7.4-1.6-.1-1.6-.9V2.6z" />
  </svg>
);

// Hudl brand mark (their square app icon via the Brandfetch CDN), linking out
// to the athlete's Hudl account where their highlights live. Falls back to
// the play glyph when the CDN image cannot load.
const HudlIcon = ({ size = 20, mono = true }) => {
  const [failed, setFailed] = useState(false);
  if (failed) return <PlayGlyph size={Math.round(size * 0.85)} />;
  return (
    <img
      src={`https://cdn.brandfetch.io/hudl.com?c=${BRANDFETCH_CLIENT_ID}`}
      alt="Hudl"
      loading="lazy"
      onError={() => setFailed(true)}
      className="rounded-[5px] object-contain"
      // mono: grayscale and hard contrast turn the orange tile black while
      // the white mark stays white, matching the other monochrome glyphs.
      style={{
        width: size + 2,
        height: size + 2,
        filter: mono ? 'grayscale(1) contrast(2.6)' : undefined,
      }}
    />
  );
};

export default HudlIcon;
